import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import Loading from '../../components/Loading/Loading';
import TextField from 'components/TextField/TextField';

//Api
import notificacao_api from '../../api/notificacao_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';
import mascaras from '../../helpers/mascaras';

//Constants
import { actionsTable } from '../../constants/MaterialTable';
import FichaNotificacao from './FichaNotificacao';
import { objCampo, validarCampos, PrintValidate } from '../../helpers/ValidadorDeCampos';

function initialStateFiltros() {
    return {
        cpfcnpj: "",
        status: "Aguardando Análise",
        dataInicial:null,
        dataFinal: null,
    }
}

export default function Notificacao() {
    //Variavel usada para navegação
    const navigate = useNavigate();

    //Variavel de controle dos dados da location
    const location = useLocation();

    //Valores que podem ter sido passados no state da rota
    const { btnVoltar, statusParam, titleTable } = location.state ? location.state : {};

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Variavel com os dados do usuario
    const usuario = getSessionCookie();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da lista de notificações
    const [items, setItems] = useState([]);

    //Estado de controle de visualização da ficha
    const [ficha, setFicha] = useState(null);

    //Estado de controle dos errors
    const [errors, setErrors] = useState({});
    //campos obrigatorios dos filtros
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ];

    //Opções dos status
    const optionsStatus = [
        { value: "Aguardando Análise", label: "Aguardando Análise" },
        { value: "Analisado e Aceitado", label: "Analisado e Aceitado" },
        { value: "Analisado e Recusado", label: "Analisado e Recusado" },
        { value: "Baixado sem Justificativa", label: "Baixado sem Justificativa" },
        { value: "Aguardando Justificativa", label: "Aguardando Justificativa" },
        { value: "Notificação confirmada sem justificativa", label: "Notificação confirmada sem justificativa" }
    ]

    //Função que faz o controle do clique na notificacao
    const onClickVisualizar = (item) => {
        setFicha(item.id);
    }

    //Ações da tabela de listagem das notificações
    const actions = [
        actionsTable.visualizar(onClickVisualizar)
    ]

    //Função que carrega as notificacoes
    const loadNotificacoes = () => {
        if (filtros.status == "Todos" || filtros.status == "Analisado e Aceitado" || filtros.status == "Analisado e Recusado" || filtros.status == "Notificação confirmada sem justificativa") {
            const _errors = validarCampos(filtros, campos);
            if (_errors[1].length > 0) {
                setErrors(_errors[0]);
                return;
            }
        }
        if ((!filtros.dataInicial && filtros.dataFinal) || (filtros.dataInicial && !filtros.dataFinal)) {
            setErrors({ ...!filtros.dataInicial ? { dataInicial: { message: "Informe a data inicial" } } : { dataFinal: { message: "Informe a data final" } } });
            return;
        }
        if ((new Date(filtros.dataInicial)).getTime() > (new Date(filtros.dataFinal)).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } });
            return;
        }

        setErrors({});

        setLoading(true);
        if (usuario.acesso.sigla != "FS") {
            notificacao_api.GetList().then(response => {
                response.data = response.data.map(value => {
                    value.dataHora = moment(value.dataHora).format("DD/MM/YYYY HH:mm");
                    value.prazoJustificativa = moment(value.prazoJustificativa).format("DD/MM/YYYY HH:mm");
                    return value;
                });
                setItems(response.data);

            })
                .catch(e => showMessage("Aviso!", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            const _filtros = { ...filtros };
            if (_filtros.dataInicial && _filtros.dataFinal) {
                _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
                _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
            }
            notificacao_api.GetListAnalise(statusParam ? { status: statusParam } : _filtros).then(response => {
                response.data = response.data.map(value => {
                    value.dataHora = moment(value.dataHora).format("DD/MM/YYYY HH:mm");
                    value.prazoJustificativa = moment(value.prazoJustificativa).format("DD/MM/YYYY HH:mm");
                    return value;
                });
                setItems(response.data);
            }).catch(e => {
                showMessage("Aviso!", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        loadNotificacoes();
    }, []);

    //Função que faz o filtro das opções dos status
    const onChangeStatus = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e ? e.value : "Todos"
        })
    }

    //OnChange do campo de cpf cnpj
    const onChangeCampos = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Cabeçalhos da tabela de notificações
    const headers = [
        { value: "Tipo de notificação", objectValue: "tbTipoNotificacao_descricao" },
        { value: "Data da notificação", objectValue: "dataHora" },
        { value: "Prazo para justificativa", objectValue: "prazoJustificativa" },
        {
            value: "Status", objectValue: "status", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    let bgStatus = "warning";

                    if (items[dataIndex].status === "Analisado e Aceitado" || items[dataIndex].status === "Baixado sem justificativa")
                        bgStatus = "success";
                    else if (items[dataIndex].status === "Analisado e Recusado" || items[dataIndex].status === "Notificação confirmada sem justificativa")
                        bgStatus = "danger";
                    return (
                        <div className='d-flex align-items-center justify-content-start'><span style={{ padding: "5px", borderRadius: "50%" }} className={`me-3 bg-${bgStatus}`}></span><span>{items[dataIndex].status}</span></div>
                    )
                }
            }
        }
    ];
    if (ficha)
        return <FichaNotificacao id={ficha} btnVoltar={() => {
            setFicha(null);
            loadNotificacoes();
        }} />
    return (
        <MainCard noCard btnVoltar={btnVoltar ? () => navigate(btnVoltar) : null}>
            {loading && <Loading />}
            {usuario.acesso.sigla === "FS" && !btnVoltar &&
                <Row>
                    <Col md="6" lg="3">
                        <TextField
                            label={`${(filtros.status == "Todos" || filtros.status == "Analisado e Aceitado" || filtros.status == "Analisado e Recusado" || filtros.status == "Notificação confirmada sem justificativa") ? "*" : ""} Data Inicial`}
                            type={"date"}
                            value={filtros.dataInicial}
                            onChange={onChangeCampos}
                            name={"dataInicial"}
                            maxLength="18"
                            invalid={!!errors.dataInicial}
                        />
                        <PrintValidate field={"dataInicial"} errors={errors} />
                    </Col>
                    <Col md="6" lg="3">
                        <TextField
                            label={`${(filtros.status == "Todos" || filtros.status == "Analisado e Aceitado" || filtros.status == "Analisado e Recusado" || filtros.status == "Notificação confirmada sem justificativa") ? "*" : ""} Data Final`}
                            type={"date"}
                            value={filtros.dataFinal}
                            onChange={onChangeCampos}
                            name={"dataFinal"}
                            maxLength="18"
                            invalid={!!errors.dataFinal}
                        />
                        <PrintValidate field={"dataFinal"} errors={errors} />
                    </Col>
                    <Col md="6" lg="3">
                        <TextField
                            label={"CPF/CNPJ"}
                            mask={mascaras.cpfcnpjMask}
                            value={filtros.cpfcnpj}
                            onChange={onChangeCampos}
                            name={"cpfcnpj"}
                            maxLength="18"
                        />
                    </Col>
                    <Col md="6" lg="3" className='mb-0'>
                        <TextField
                            label={"* Status"}
                            type="select"
                            options={optionsStatus}
                            searchable
                            placeholder='Todos'
                            value={optionsStatus.filter(value => value.value === filtros.status)[0]}
                            name={"status"}
                            onChange={onChangeStatus}
                        />
                    </Col>
                    <Col md="6" lg="4" className='mb-3 mt-1'>
                        <Button onClick={loadNotificacoes} color='primary' ><FontAwesomeIcon icon={faSearch} /> Pesquisar</Button>
                    </Col>
                </Row>}
            <TabelaListagem title={titleTable ? titleTable : "Tabela de notificações"} items={items} headers={headers} actions={actions} />
        </MainCard>
    );
}